module.exports = __webpack_public_path__ + "img/LivingRoom.88da19f6.jpg";